<template>
  <b-container fluid>
    <div class="receipt-body styled-receipt">
      <div class="receipt-content">
        <b-row class="receipt-row text-center header-row">
          <b-col cols="2">Descrição</b-col>
          <b-col cols="3">Valor</b-col>
          <b-col cols="4">Não Conciliado</b-col>
        </b-row>

        <b-row
          v-for="(sell, index) in sellData"
          :key="index"
          class="receipt-row align-items-center"
        >

          <b-col cols="4">
            <span class="receipt-label">{{ sell.title }}:</span>
          </b-col>
          <b-col cols="4">
            <template v-if="sell.title === 'Estabelecimentos' && sell.message">
              <b-button
                variant="link"
                class="p-0 receipt-value clickable"
                @click="$emit('open-table', 'Estabelecimentos')"
              >
                {{ sell.message }}
              </b-button>
            </template>
            <template v-else>
              <span class="receipt-value">{{ sell.message }}</span>
            </template>
          </b-col>

          <b-col cols="4" class="d-flex justify-content-center">
            <template v-if="sell.title === 'Estabelecimentos'">
              <b-button
                variant="link"
                class="p-0 clickable"
                @click="$emit('open-table', 'Estabelecimentos')"
              >
                <i class="fas fa-eye eye-icon"></i>
              </b-button>
            </template>
            <template v-else-if="sell.title === 'Outros status'">
              <b-button
                variant="link"
                class="p-0 clickable"
                @click="$emit('open-table', 'Outros status')"
              >
                <i class="fas fa-eye eye-icon"></i>
              </b-button>
            </template>


            <template v-else-if="sell.title === 'Fora de data'">
              <b-button
                variant="link"
                class="p-0 clickable"
                @click="$emit('open-table', 'Fora de data')"
              >
                <i class="fas fa-eye eye-icon"></i>
              </b-button>
            </template>
            
            <template v-else>
              <span
                class="receipt-extra"
                v-if="sell.title === 'Edi Rede' || sell.title === 'Veripag' || sell.title === 'Gateway'"
                v-b-tooltip.hover
                title="Valor não conciliado"
              >
                {{ sell.extra }}
              </span>
              <span v-else class="receipt-extra">
                {{ sell.extra }}
              </span>
            </template>
          </b-col>
        </b-row>

        <b-row v-if="type === 'transaction'" class="receipt-row">
          <b-col cols="6" class="d-flex align-items-center">
            <b-button class="help-button"></b-button>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-container>
</template>


<script>
import { BContainer, BRow, BCol, BButton, VBTooltip } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BButton,
    BContainer,
    BCol,
    BRow,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  props: ["receiptData", "type"],
 data() {
  return {
    sellData: [
      { title: "PIX (Itaú) ", message: "R$ 0,00", extra: "R$ 0,00" },
      { title: "Edi Rede", message: "R$ 0,00", extra: "R$ 0,00" },
      { title: "Veripag", message: "R$ 0,00", extra: "R$ 0,00" },
      { title: "Fora de data", message: "R$ 0,00", extra: "Ver detalhes" },
      { title: "Gateway", message: "R$ 0,00", extra: "R$ 0,00" },
      { title: "Processando", message: "R$ 0,00", extra: "--" },
      { title: "Pendente", message: "R$ 0,00", extra: "--" },
      { title: "Outros status", message: "R$ 0,00", extra: "Ver detalhes" },
      { title: "Valor Pago", message: "R$ 0,00", extra: "--" },
      { title: "Valor Antecipado", message: "R$ 0,00", extra: "--" },
      { title: "Estabelecimentos", message: "0 nova alteração" },
    ],
  };
},

watch: {
  receiptData: {
    immediate: true,
    handler(newVal) {
      if (newVal) {
        this.updateReceiptData(newVal);
      }
    },
  },
},

methods: {
  formatBRL(value) {
    return `R$ ${Number(value || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`;
  },
  
  updateReceiptData(dataFromServer) {
  const { veripag, pix, rede, processing_or_pending: processing, outOfDate, gateway, othersStatus, paid_and_antecipated, establishment } = dataFromServer;

  const totalEstChanges = establishment?.length || 0;
  const changeText = totalEstChanges === 1 ? "1 nova alteração" : `${totalEstChanges} novas alterações`;

  const receiptMap = [
    { title: "Edi Rede", dataKey: "rede", valueKey: "gross_amount", extraKey: "not_conciliated" },
    { title: "Veripag", dataKey: "veripag", valueKey: "gross_amount", extraKey: "not_conciliated" },
    { title: "PIX (Itaú)", dataKey: "pix.itau", valueKey: "gross_amount", extraKey: "not_conciliated" },
    { title: "Fora de data", dataKey: "outOfDate", valueKey: "gross_amount", extraText: "Ver detalhes" },
    { title: "Gateway", dataKey: "gateway", valueKey: "gross_amount", extraKey: "not_conciliated" },
    { title: "Processando", dataKey: "processing_or_pending", valueKey: "processing" },
    { title: "Pendente", dataKey: "processing_or_pending", valueKey: "pending" },
    { title: "Outros status", dataKey: "othersStatus", valueKey: "gross_amount", extraText: "Ver detalhes" },
    { title: "Valor Pago", dataKey: "paid_and_antecipated", valueKey: "paid", extraText: "--" },
    { title: "Valor Antecipado", dataKey: "paid_and_antecipated", valueKey: "antecipated", extraText: "--" },
    { title: "Estabelecimentos", dataKey: "establishment", custom: () => ({ message: changeText }) },
  ];

  this.sellData = receiptMap.map(item => {
    if (item.custom) return { title: item.title, ...item.custom() };

    const dataObj = item.dataKey.split('.').reduce((acc, key) => acc?.[key], dataFromServer);
    return {
      title: item.title,
      message: this.formatBRL(dataObj?.[item.valueKey]),
      extra: item.extraKey ? this.formatBRL(dataObj?.[item.extraKey]) : item.extraText || "--",
    };
  });
}
},
};
</script>

<style lang="scss" scoped>
.help-button {
  padding: 0;
  background-color: transparent !important;
  border: none;
}

.receipt-body:after {
  bottom: 0;
  background: linear-gradient(45deg, #f8f6f6 33.333%, transparent 0),
    linear-gradient(-45deg, #f8f6f6 33.333%, transparent 0);
  border: none;
}

.receipt-body {
  background-color: #ffffff;
  border-radius: 12px;
  max-width: 500px;
  margin: auto;
  padding: 2rem;
  position: relative;
  overflow: hidden;
}

.receipt-body:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 16px;
  background-color: #f8f6f6;
  clip-path: polygon(
    0% 100%,
    5% 0%,
    10% 100%,
    15% 0%,
    20% 100%,
    25% 0%,
    30% 100%,
    35% 0%,
    40% 100%,
    45% 0%,
    50% 100%,
    55% 0%,
    60% 100%,
    65% 0%,
    70% 100%,
    75% 0%,
    80% 100%,
    85% 0%,
    90% 100%,
    95% 0%,
    100% 100%
  );
}

.bg-logo {
  display: block;
  max-width: 200px;
  margin: 0 auto 1rem auto;
  margin-bottom: 20px;
}

.subtitle {
  font-weight: 600;
  font-size: 1.2rem;
  color: #333;
  margin-bottom: 1rem;
  text-align: center;
}

.receipt-row {
  padding: 0.8rem 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px dotted #999;
  border-bottom-width: 1.2px;

  &:last-child {
    border-bottom: none;
  }
}

.receipt-label {
  font-weight: 700;
  color: #555;
}

.receipt-value {
  font-weight: 500;
  color: #333;
}

.help-button {
  padding: 0;
  margin-left: 0.3rem;
  background-color: transparent !important;
  border: none;
}

.feather-help-circle {
  color: gray;
}

.eye-icon {
  font-size: 1.2rem;
  color: #555;
  transition: 0.2s;
}

.eye-icon:hover {
  color: #000;
}

.header-row {
  font-weight: 800 !important;
  color:var(--primary)
}

</style>
